import { useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export default function useCompanyUID() {
  const { currentUser } = useAuth();
  const [companyUID, setCompanyUID] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const resolve = async () => {
      if (!currentUser) {
        setCompanyUID('');
        setLoading(false);
        return;
      }

      try {
        const ownerSnap = await get(ref(database, `companies/${currentUser.uid}`));
        if (ownerSnap.exists()) {
          setCompanyUID(currentUser.uid);
          return;
        }

        const collabSnap = await get(ref(database, `collaborators/${currentUser.uid}`));
        if (collabSnap.exists()) {
          const collaboratorData = collabSnap.val() || {};
          setCompanyUID(collaboratorData.companyId || collaboratorData.company_uid || '');
          return;
        }

        setCompanyUID('');
      } catch (err) {
        console.error('Error resolving company UID:', err);
        setCompanyUID('');
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    resolve();
  }, [currentUser]);

  return { companyUID, loading };
}
